export default __webpack_public_path__ + "static/media/privilege-gift.a0628db1.svg";